module.exports = __webpack_public_path__ + "img/ruutu_logo.194a1937.png";